import React, { useContext, useState } from "react";
import { ProductContext } from "../../../../stores/session";
import './StatusFilter.scss'

export default function StatusFilter({ statusCounts, selectedStatus, setSelectedStatus }) {
    const { statuses } = useContext(ProductContext)

    return (
        <div className="status-bar">
            {
                statuses.map(status => {
                    const selected = selectedStatus === status;
                    const count = statusCounts?.find(count => count.status.toLowerCase() === status.toLowerCase())?.count
                    return (
                        <button
                            className={`button compact smaller-text ${selected ? "bulk-buy-button" : "background-primary"} colour-white`}
                            onClick={() => {
                                setSelectedStatus(status)
                            }}
                        >
                            {status} ({count ?? 0})
                        </button>
                    )
                })
            }
        </div>
    )
}